import React from 'react';
import ReactDOM from 'react-dom';
import { DefaultFooter } from './DefaultFooter';

export const PageFooter = () => {
  const defaultFooterMountElem = document.getElementById(
    'ol-default-footer-mount'
  );

  if (defaultFooterMountElem) {
    return ReactDOM.createPortal(<DefaultFooter />, defaultFooterMountElem);
  }
  return null;
};
